import http from "@/settings/apiSettings"

class TipRetinereService {
    save(data: any) : Promise<any> {
        return http.clientResurseUmaneOdata.post("/RU_TipRetinere", data)
    }
}
export default new TipRetinereService()